export const pathUrlS3 = 'https://rappi-uploads-01-prod.s3-us-west-2.amazonaws.com/portal-docs/selfonboard/images/';
export const ARGENTINIAN_FLAG_IMG = `${pathUrlS3}flags/ar.svg`;
export const BRAZILIAN_FLAG_IMG = `${pathUrlS3}flags/br.svg`;
export const CHILEAN_FLAG_IMG = `${pathUrlS3}flags/cl.svg`;
export const COLOMBIAN_FLAG_IMG = `${pathUrlS3}flags/co.svg`;
export const COSTARICAN_FLAG_IMG = `${pathUrlS3}flags/cr.svg`;
export const ECUADORIAN_FLAG_IMG = `${pathUrlS3}flags/ec.svg`;
export const MEXICAN_FLAG_IMG = `${pathUrlS3}flags/mx.svg`;
export const PERUVIAN_FLAG_IMG = `${pathUrlS3}flags/pe.svg`;
export const URUGUAYAN_FLAG_IMG = `${pathUrlS3}flags/uy.svg`;
export const countryByCode = {
    AR: {
        code: 'AR',
        name: 'Argentina',
        flag: ARGENTINIAN_FLAG_IMG,
    },
    BR: {
        code: 'BR',
        name: 'Brasil',
        flag: BRAZILIAN_FLAG_IMG,
    },
    CL: {
        code: 'CL',
        name: 'Chile',
        flag: CHILEAN_FLAG_IMG,
    },
    CO: {
        code: 'CO',
        name: 'Colombia',
        flag: COLOMBIAN_FLAG_IMG,
    },
    CR: {
        code: 'CR',
        name: 'Costa Rica',
        flag: COSTARICAN_FLAG_IMG,
    },
    EC: {
        code: 'EC',
        name: 'Ecuador',
        flag: ECUADORIAN_FLAG_IMG,
    },
    MX: {
        code: 'MX',
        name: 'México',
        flag: MEXICAN_FLAG_IMG,
    },
    PE: {
        code: 'PE',
        name: 'Perú',
        flag: PERUVIAN_FLAG_IMG,
    },
    UY: {
        code: 'UY',
        name: 'Uruguay',
        flag: URUGUAYAN_FLAG_IMG,
    },
};
export const countries = Object.values(countryByCode);
